/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DrinkMarginDto } from '../../models/drink-margin-dto';

export interface DrinkStatsControllerGetDrinkMargin$Params {
  dateFrom?: string;
  dateTo?: string;
}

export function drinkStatsControllerGetDrinkMargin(http: HttpClient, rootUrl: string, params?: DrinkStatsControllerGetDrinkMargin$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DrinkMarginDto>>> {
  const rb = new RequestBuilder(rootUrl, drinkStatsControllerGetDrinkMargin.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DrinkMarginDto>>;
    })
  );
}

drinkStatsControllerGetDrinkMargin.PATH = '/drink-stats/margin';
